module.exports = __webpack_public_path__ + "img/print.3ac160a3.svg";